export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14022.1c0f1066.jpg";